<!-- Main container -->
<div class="data-param-section">

  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center"
         (click)="isCardVisible = !isCardVisible"
         style="cursor: pointer;">
      <h3 class="h5 mb-0 mr-1">Data Parameters & Test Data</h3>
      <button class="btn btn-sm btn-outline-secondary" type="button">
        <i class="fa" [ngClass]="isCardVisible ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
      </button>
    </div>

    <div class="card-body p-3" *ngIf="isCardVisible">

      <!-- Action Buttons -->
      <div class="mb-3">
        <div class="d-flex justify-content-start align-items-center">
          <button type="button" class="btn btn-sm btn-primary"
                  (click)="generateTableData()"
                  [disabled]="isGenerating || editingRowIndex !== null || isAddingNew">
            <span *ngIf="isGenerating" class="spinner-border spinner-border-sm me-1"></span>
            <i *ngIf="!isGenerating" class="fa fa-cogs me-1 mr-1"></i>
            <span>{{ isGenerating ? 'Generating...' : 'Generate Data' }}</span>
          </button>

          <button *ngIf="baseDatasetItems.length > 0" class="btn btn-sm btn-success ml-2" (click)="onAddNew()" [disabled]="editingRowIndex !== null || isAddingNew">
            <i class="fa fa-plus me-1"></i> Add Parameter
          </button>
        </div>

        <div *ngIf="generationError" class="alert alert-danger mt-2">
          {{ generationError }}
          <button type="button" class="btn-close" (click)="generationError = null"></button>
        </div>
      </div>

      <!-- Table -->
      <div *ngIf="dataParameters">
        <div class="table-responsive">
          <table class="table table-sm table-hover table-bordered mb-0">
            <thead class="table-light">
            <tr>
              <th style="width: 10%; text-align:center;">Type</th> <!-- NEW COLUMN -->
              <th style="width: 20%;">Field</th>
              <th style="width: 20%;">Valid Values</th>
              <th style="width: 20%;">Invalid Values</th>
              <th>Rules</th>
              <th style="width: 1%; text-align: center;">Actions</th>
            </tr>
            </thead>
            <tbody>

            <!-- ADD NEW ROW -->
            <tr *ngIf="isAddingNew" class="table-info edit-row">
              <td class="text-center text-muted small align-middle">
                <em>Auto</em>
              </td>
              <td><textarea class="form-control" [(ngModel)]="newRowData.field" placeholder="[INP] Name" rows="2"></textarea></td>
              <td><textarea class="form-control" [ngModel]="newRowData.valid_values?.join(', ')" (ngModelChange)="updateArrayValue(newRowData, 'valid_values', $event)" rows="2"></textarea></td>
              <td><textarea class="form-control" [ngModel]="newRowData.invalid_values?.join(', ')" (ngModelChange)="updateArrayValue(newRowData, 'invalid_values', $event)" rows="2"></textarea></td>
              <td><textarea class="form-control" [(ngModel)]="newRowData.rules" rows="2"></textarea></td>
              <td class="actions-cell align-middle">
                <button class="btn btn-sm btn-action-save" (click)="onSaveNew()"><i class="fa fa-check"></i></button>
                <button class="btn btn-sm btn-action-cancel" (click)="cancelEdit()"><i class="fa fa-times"></i></button>
              </td>
            </tr>

            <!-- EXISTING ROWS -->
            <ng-container *ngFor="let item of baseDatasetItems; let i = index">

              <!-- READ MODE -->
              <tr *ngIf="editingRowIndex !== i" [class.table-active]="editingRowIndex === i">

                <!-- 1. TYPE COLUMN (Parsed) -->
                <td class="align-middle text-center">
                  <ng-container *ngIf="parseField(item.field) as p">
                    <span class="badge-type"
                          [ngClass]="{'badge-ctx': p.type === 'CTX', 'badge-inp': p.type === 'INP'}"
                          [title]="getTypeDefinition(p.type)">
                      {{ p.type === 'CTX' ? 'CONTEXT' : (p.type === 'INP' ? 'INPUT' : 'PARAM') }}
                    </span>
                  </ng-container>
                </td>

                <!-- 2. FIELD COLUMN (Name Only) -->
                <td class="align-middle">
                  <span class="field-name">{{ parseField(item.field).name }}</span>
                </td>

                <!-- 3. VALID VALUES (Cleaned) -->
                <td class="align-middle">
                  <div class="chips-container">
                    <span *ngFor="let val of item.valid_values" class="value-chip valid">
                      {{ getCleanValue(val) }}
                    </span>
                    <span *ngIf="!item.valid_values?.length" class="text-muted small">-</span>
                  </div>
                </td>

                <!-- 4. INVALID VALUES (Cleaned) -->
                <td class="align-middle">
                  <div class="chips-container">
                    <span *ngFor="let val of item.invalid_values" class="value-chip invalid">
                      {{ getCleanValue(val) }}
                    </span>
                    <span *ngIf="!item.invalid_values?.length" class="text-muted small">-</span>
                  </div>
                </td>

                <!-- 5. RULES (Purpose Only) -->
                <td class="align-middle">
                  <span class="rule-text">{{ getCleanRule(item.rules) }}</span>
                </td>

                <!-- 6. ACTIONS -->
                <td class="actions-cell align-middle">
                  <button class="btn btn-sm btn-action-edit" (click)="onEdit(item, i); $event.stopPropagation()">
                    <i class="fa fa-pencil"></i>
                  </button>
                  <button class="btn btn-sm btn-action-delete" (click)="onDelete(i); $event.stopPropagation()">
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>

              <!-- EDIT MODE (Shows Raw Data for editing precision) -->
              <tr *ngIf="editingRowIndex === i" class="table-info edit-row">
                <td class="align-middle text-center text-muted small"><em>Edit</em></td>
                <td><textarea class="form-control" [(ngModel)]="item.field" rows="3"></textarea></td>
                <td><textarea class="form-control" [ngModel]="item.valid_values?.join(', ')" (ngModelChange)="updateArrayValue(item, 'valid_values', $event)" rows="3"></textarea></td>
                <td><textarea class="form-control" [ngModel]="item.invalid_values?.join(', ')" (ngModelChange)="updateArrayValue(item, 'invalid_values', $event)" rows="3"></textarea></td>
                <td><textarea class="form-control" [(ngModel)]="item.rules" rows="3"></textarea></td>
                <td class="actions-cell align-middle">
                  <button class="btn btn-sm btn-action-save" (click)="onSave(i); $event.stopPropagation()"><i class="fa fa-check"></i></button>
                  <button class="btn btn-sm btn-action-cancel" (click)="cancelEdit(); $event.stopPropagation()"><i class="fa fa-times"></i></button>
                </td>
              </tr>

            </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
